import request from '@/common/js/request'

/**
 * 专题详情
 */
export const columnColumnIdGet = (option = {}) => {
    return request({
        url: '/apis/column/{columnId}',
        method: 'get',
        ...option
    })
}

/**
 * 专题话题
 * @param {*} option 
 */
export const columnColumnIdArticlesGet = (option = {}) => {
    return request({
        url: '/apis/column/{columnId}/articles',
        method: 'get',
        ...option
    })
}

